import React from 'react';
import ReactDOM from 'react-dom';
import useGlobalLinkIndicatorPositionStyles from 'components/text-editor/components/controls/hooks/use-global-link-indicator-position-style';
import {
  Container,
  Bubble,
  Section,
  BubbleContainer,
} from 'components/text-editor/components/annotations/components/global-link-indicator/style';
import { ReactComponent as Tail } from 'components/text-editor/components/annotations/components/global-link-indicator/tail.svg';
import { textEditorClassName } from 'components/text-editor/style';
import useAnnotationMarkPositionStyles from 'components/text-editor/components/annotations/components/hooks/use-annotation-mark-position-styles';

interface Props {
  isVisible: boolean;
  element: any;
  count: number | string | undefined;
  onClick?: Function;
}

/**
 * The GlobalLinkIndicator is a used to display the number of links
 * a text snippet has and to open the SideDrawer (when the user click on it).
 */
export default function GlobalLinkIndicator({
  element,
  count,
  onClick,
  ...props
}: Props) {
  const positionStyles = useGlobalLinkIndicatorPositionStyles(element);

  const linkIndicatorPosition = useAnnotationMarkPositionStyles(
    element,
    'right',
  );

  positionStyles.left = linkIndicatorPosition?.left;
  positionStyles.marginLeft = linkIndicatorPosition?.marginLeft;

  const [textEditorElement] = document.getElementsByClassName(
    textEditorClassName,
  );

  function onClickHandler(event) {
    if (props.isVisible) {
      onClick && onClick(event);
    }
  }

  if (textEditorElement?.parentNode) {
    const portalElement = (
      <Container {...props} contentEditable={false} style={positionStyles}>
        {count ? (
          <BubbleContainer height={positionStyles?.height}>
            <Section height={positionStyles?.height}>
              <Bubble isVisible={props.isVisible} onClick={onClickHandler}>
                {count}
              </Bubble>
              <Tail />
            </Section>
          </BubbleContainer>
        ) : null}
      </Container>
    );

    return ReactDOM.createPortal(
      portalElement,
      textEditorElement.parentNode as HTMLElement,
    );
  }

  return null;
}
